export default "__VITE_ASSET__BXVbYRY0__"